import React, { useState, useEffect, useContext, useRef } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { Accordion, AccordionTab } from 'primereact/accordion';
import { Tag } from "primereact/tag";
import { Dropdown } from 'primereact/dropdown'
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import Backdrop from '@mui/material/Backdrop';
import CircularProgress from '@mui/material/CircularProgress';
import { Toast } from "primereact/toast";
import { Calendar } from 'primereact/calendar'
import htmlDocx from "html-docx-js/dist/html-docx";
import {
  Document,
  Packer,
  Paragraph,
  TextRun,
  HeadingLevel,
  ImageRun,
  Header,
  AlignmentType,
  Table,
  TableRow,
  TableCell,
  WidthType,
  BorderStyle
} from "docx";
import { saveAs } from "file-saver";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import logoILaw from "../../pages/seguranca/img/logo_login.png";
import AtividadeComponent from "../atividades/AtividadeComponent"
import AtividadeComponentInclusao from "../atividades/AtividadeComponentInclusao";
import Atividades from "./Atividades";
import DashboardPublicacoes from "./DashboardPublicacoes";
import PublicacoesService from "../../app/service/PublicacoesService";
import StatusProcessualService from "../../app/service/StatusProcessualService";
import AtividadeService from "../../app/service/AtividadeService";
import TipoDecisaoService from "../../app/service/TipoDecisao";
import ProcessoService from "../../app/service/ProcessoService";
import ResumoIntimacaoIaService from "../../app/service/ResumoIntimacaoIaService";

import { AuthContext } from '../../main/ProvedorAutenticacao'

const PaginaPublicacaoDetalhada = ({ publicacoes, setPublicacoes, filtro }) => {

  const [lidas, setLidas] = useState({});
	const [modalAtividades, setModalAtividades] = useState(false);
	const [modalAtividadePublicacao, setModalAtividadePublicacao] = useState(false);
	const [modalAtividadeInclusao, setModalAtividadeInclusao] = useState(false);
	const [atividades, setAtividades] = useState({});
	const [openSpinner, setOpenSpinner] = useState(false);
  const { usuarioAutenticado } = useContext(AuthContext);
	const [statusProcessual, setStatusProcessual] = useState(null);
	const [statusProcessuais,setStatusProcessuais] = useState([]);
	const [tipoDecisao, setTipoDecisao] = useState(null);
	const [tiposDecisao,setTiposDecisao] = useState([]);
	const [dataUltimaDecisao, setDataUltimaDecisao] = useState(null);
	const [dataDistribuicao, setDataDistribuicao] = useState(null);
	const [dataSentenca, setDataSentenca] = useState(null);
	const [atividadeSelecionada,setAtividadeSelecionada] = useState({});
	const [processoSelecionado,setProcessoaSelecionado] = useState(null);
	const [publicacaoSelecionada,setPublicacaoSelecionada] = useState({});
	const [ historicoAtividade, setHistoricoAtividade] = useState([]);
	const toast = useRef(null);

	const service = new PublicacoesService();
	const statusProcessualService = new StatusProcessualService();
	const tipoDecisaoService = new TipoDecisaoService();
	const atividadeService = new AtividadeService();
	const processoService = new ProcessoService();
	const resumoIntimacaoIaService = new ResumoIntimacaoIaService();

	useEffect(() => {
		const usuarioLogado = usuarioAutenticado;
		const verificarLidas = async () => {
			const resultado = {};

			listarStatusProcessuais(usuarioLogado.empresa.codigo);
			listarTiposDecisao(usuarioLogado.empresa.codigo);

			for (let pub of publicacoes) {
				try {
					const response = await service.consultarPublicacaoLida(
						pub.codigo,
						usuarioLogado.codigo
					);

					// Se chegou aqui, está lida
					if (response.data && response.data.codigo) {
						resultado[pub.codigo] = true;
					}

				} catch (error) {
					// Se for 404 → não está lida
					if (error.response?.status !== 404) {
						console.error("Erro ao consultar:", error);
					}
				}
			}

			setLidas(resultado);
		};

		if (publicacoes?.length) {
			verificarLidas();
		}

	}, [publicacoes]);

	const listarStatusProcessuais = (empresa) => {
		statusProcessualService.listarStatusProcessual(empresa)
      .then(response => {
        setStatusProcessuais(response.data);
      }).catch(error => {
				console.log('error ', error);
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Status Processual', life: 4000});
      })
	}

	const listarTiposDecisao = (empresa) => {
    tipoDecisaoService.listarTiposDecisao(empresa)
      .then(response => {
        setTiposDecisao(response.data);
      }).catch(error => {
        this.toast.show({severity:'error', summary: 'Processos', detail:'Erro ao carregar Tipos de Decisão', life: 4000});
      })
  }

	const converterData = (dataString) => {
    if (!dataString) return null;
    const [ano, mes, dia] = dataString.split("-");
    return new Date(ano, mes - 1, dia);
	};

  if (!Array.isArray(publicacoes) || publicacoes?.length === 0) {
    return <p>Nenhuma publicação encontrada.</p>;
  }

  /* =========================
     AÇÕES
  ========================= */

  const toggleLida = (index) => {
    setLidas(prev => ({
      ...prev,
      [index]: !prev[index]
    }));
  };

	const confirmarMarcarComoLida = async (publicacao, index) => {
		const usuarioLogado = usuarioAutenticado;
		const response = await service.consultarPublicacaoLida(
			publicacao.codigo,
			usuarioLogado.codigo
		);

		if (response.data && response.data.codigo) {
			//Remove a publicacaoLida
			confirmDialog({
				message: "Deseja realmente retornar esta publicação para pendente ?",
				header: "Confirmação",
				icon: "pi pi-question-circle",
				acceptLabel: "Sim",
				rejectLabel: "Não",
				accept: () => removerPublicacaoLida(publicacao, index),
			});
		} else {
			//Marca como lida
			confirmDialog({
				message: "Deseja realmente marcar esta publicação como lida?",
				header: "Confirmação",
				icon: "pi pi-question-circle",
				acceptLabel: "Sim",
				rejectLabel: "Não",
				accept: () => marcarComoLida(publicacao, index),
			});
		}
	};

	const marcarComoLida = async (publicacao, index) => {
		try {
			const usuarioLogado = usuarioAutenticado;
			const request = {
				publicacao: {
					codigo: publicacao.codigo
				},
				usuario: {
					codigo: usuarioLogado.codigo
				}
			}
			setOpenSpinner(true);
			await service.marcarPublicacaoComoLida(request);
			setOpenSpinner(false);
	
			setLidas(prev => ({
				...prev,
				[publicacao.codigo]: true
			}));

			toast.current.show({
				severity: "success",
				summary: "Publicações",
				detail: "Publicação marcada como lida",
				life: 4000
			});

		} catch (error) {
			console.log(error);
		}
	};

	const removerPublicacaoLida = async (publicacao,index) => {
		try {
			const usuarioLogado = usuarioAutenticado;
			setOpenSpinner(true);
			const response = await service.removerPublicacaoLida(publicacao.codigo,usuarioLogado.codigo);
			setLidas(prev => ({
				...prev,
				[publicacao.codigo]: false
			}));
			toast.current.show({
				severity: "success",
				summary: "Publicações",
				detail: "Publicação retornada para pendente",
				life: 4000
			});
			setOpenSpinner(false);
		} catch (error) {
			setOpenSpinner(false);
			toast.current.show({
					severity: "error",
					summary: "Publicações",
					detail: `${error}`,
					life: 4000
				});
		}
	}

	const consultarPublicacaoLida = async (publicacao) => {
		const usuarioLogado = usuarioAutenticado;
		await service.consultarPublicacaoLida(publicacao.codigo,usuarioLogado.codigo)
			.then(response => {
				console.log('Aqui eu quero mudar a cor do toggleLida');
			}).catch(error => {
				console.log('Erro ', error);
				toast.current.show({severity:'error', summary: 
														'Atividades', 
														detail:'Nã foi possivel consultar a publicação', life: 4000});
			})
	}

	const consultaAtividades = (atividades) => {
		setModalAtividades(true);
		setAtividades(atividades)
	}

  const gerarLinkProcesso = (pub) => {
    return `#/fichaProcesso/${pub.processo.codigo}/SEARCH`;
  };

  /* =========================
     COR TRIBUNAL
  ========================= */

  const getTribunalColor = (tribunal) => {

    if (!tribunal) return "info";

    if (tribunal.includes("TRT")) return "warning";
    if (tribunal.includes("TJ")) return "success";
    if (tribunal.includes("STJ")) return "danger";

    return "info";
  };

  /* =========================
     DESTAQUE NOMES
  ========================= */

	const escapeRegex = (texto) => {
		return texto.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	};

  const destacarTexto = (texto, pub) => {

    if (!texto) return "";

    let nomes = [];

    if (Array.isArray(pub.destinatarios))
      nomes = nomes.concat(pub.destinatarios.map(d => d.nome));

    if (Array.isArray(pub.destinatariosAdvogados))
      nomes = nomes.concat(pub.destinatariosAdvogados.map(a => a.nome));

    let resultado = texto;

    nomes.forEach(nome => {

			const nomeSeguro = escapeRegex(nome);
			const regex = new RegExp(`(${nomeSeguro})`, "gi");

      //const regex = new RegExp(`(${nome})`, "gi");

      resultado = resultado.replace(
        regex,
        `<span style="background:yellow;font-weight:bold">$1</span>`
      );
    });

    return resultado;
  };

  const carregarImagemBuffer = async (imagem) => {
    const response = await fetch(imagem);
    return await response.arrayBuffer();
  };



  const gerarWord = async (pub) => {
    const imageBuffer = await carregarImagemBuffer(logoILaw);
    const doc = new Document({
      sections: [
        {
          headers: {
            default: new Header({
              children: [

                // TABELA COM LOGO + ENDEREÇO
                new Table({
                  width: {
                    size: 100,
                    type: WidthType.PERCENTAGE
                  },
                  borders: {
                    top: { style: BorderStyle.NONE },
                    bottom: { style: BorderStyle.NONE },
                    left: { style: BorderStyle.NONE },
                    right: { style: BorderStyle.NONE },
                    insideHorizontal: { style: BorderStyle.NONE },
                    insideVertical: { style: BorderStyle.NONE }
                  },
                  rows: [
                    new TableRow({
                      children: [

                        // LOGO ESQUERDA
                        new TableCell({
                          width: { size: 30, type: WidthType.PERCENTAGE },
                          borders: { top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE }, left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE } },
                          children: [
                            new Paragraph({
                              children: [
                                new ImageRun({
                                  data: imageBuffer,
                                  transformation: {
                                    width: 120,
                                    height: 60
                                  }
                                })
                              ]
                            })
                          ]
                        }),

                        // ENDEREÇO DIREITA
                        new TableCell({
                          width: { size: 70, type: WidthType.PERCENTAGE },
                          borders: { top: { style: BorderStyle.NONE }, bottom: { style: BorderStyle.NONE }, left: { style: BorderStyle.NONE }, right: { style: BorderStyle.NONE } },
                          children: [

                            new Paragraph({
                              alignment: AlignmentType.LEFT,
                              text: "Fones: (83) 9.98130-0623"
                            }),

                            new Paragraph({
                              alignment: AlignmentType.LEFT,
                              text: "contato@ilawgestao.com.br"
                            }),

                            new Paragraph({
                              alignment: AlignmentType.LEFT,
                              text: "www.ilawgestao.com.br"
                            })
                          ]
                        })

                      ]
                    })
                  ]
                }),

                new Paragraph(""),

                // CLIENTE E QUANTIDADE
                new Paragraph({
                  children: [
                    new TextRun({ text: "Cliente : ", bold: true }),
                    new TextRun("Cliente")
                  ]
                }),

                // LINHA SEPARADORA
                new Paragraph({
                  border: {
                    bottom: {
                      color: "auto",
                      space: 1,
                      style: BorderStyle.SINGLE,
                      size: 6
                    }
                  }
                }),
              ]
            })
          },

          children: [

            new Paragraph({
              text: "Publicação Jurídica",
              heading: HeadingLevel.HEADING_1
            }),

            new Paragraph(""),

            new Paragraph({
              children: [
                new TextRun({ text: "Data da Disponibilização: ", bold: true }),
                new TextRun(pub.dataDisponibilizacao || "")
              ]
            }),

            new Paragraph({
              children: [
                new TextRun({ text: "Data da Publicação: ", bold: true }),
                new TextRun(pub.dataPublicacao || "")
              ]
            }),

            new Paragraph({
              children: [
                new TextRun({ text: "Tribunal: ", bold: true }),
                new TextRun(pub.tribunal || "")
              ]
            }),

            new Paragraph({
              children: [
                new TextRun({ text: "Processo: ", bold: true }),
                new TextRun(pub.processo?.nrCnj || "")
              ]
            }),

            new Paragraph({
              children: [
                new TextRun({ text: "Vara: ", bold: true }),
                new TextRun(pub.vara || "")
              ]
            }),

            new Paragraph(""),

            new Paragraph({
              text: "Publicação",
              heading: HeadingLevel.HEADING_2
            }),

            new Paragraph(pub.pulicacao || ""),

            new Paragraph(""),

            new Paragraph({
              text: "Destinatários",
              heading: HeadingLevel.HEADING_2
            }),

            ...(pub.destinatarios || []).map(d =>
              new Paragraph(`• ${d.nome} (${d.polo || ""})`)
            ),

            new Paragraph(""),

            new Paragraph({
              text: "Advogados",
              heading: HeadingLevel.HEADING_2
            }),

            ...(pub.destinatariosAdvogados || []).map(a =>
              new Paragraph(`• ${a.nome} - OAB ${a.oab || ""}`)
            )

          ]
        }
      ]
    });

    const blob = await Packer.toBlob(doc);
    saveAs(blob, `publicacao_${pub.processo?.nrCnj || "arquivo"}.docx`);
  };


  const gerarPDF = async (pub) => {

    const doc = new jsPDF();

    // ===== FUNÇÃO SEGURA PARA TEXTO =====
    const safeText = (valor) => {
      if (!valor) return "";
      if (typeof valor === "string") return valor;
      return JSON.stringify(valor);
    };

    // ===== CONVERTER IMAGEM PARA BASE64 =====
    const carregarImagemBase64 = async (src) => {
      const response = await fetch(src);
      const blob = await response.blob();

      return new Promise((resolve) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
      });
    };

    const logoBase64 = await carregarImagemBase64(logoILaw);

    // ===== CABEÇALHO =====
    doc.addImage(logoBase64, "PNG", 10, 10, 40, 20);

    doc.setFontSize(10);
    doc.text("Fones: (83) 9.98130-0623", 60, 15);
    doc.text("contato@ilawgestao.com.br", 60, 20);
    doc.text("www.ilawgestao.com.br", 60, 25);

    // Cliente
    doc.setFontSize(11);
    doc.text("Cliente : Cliente", 10, 40);

    // Linha separadora
    doc.line(10, 43, 200, 43);

    let y = 55;

    // ===== TÍTULO =====
    doc.setFontSize(16);
    doc.text("Publicação Jurídica", 10, y);
    y += 10;

    // ===== DADOS =====
    doc.setFontSize(11);

    doc.text(`Data da Disponibilização: ${safeText(pub.dataDisponibilizacao)}`, 10, y);
    y += 7;

    doc.text(`Data da Publicação: ${safeText(pub.dataPublicacao)}`, 10, y);
    y += 7;

    doc.text(`Tribunal: ${safeText(pub.tribunal)}`, 10, y);
    y += 7;

    doc.text(`Processo: ${safeText(pub.processo?.nrCnj)}`, 10, y);
    y += 7;

    doc.text(`Vara: ${safeText(pub.vara)}`, 10, y);
    y += 12;

    // ===== PUBLICAÇÃO =====
    doc.setFontSize(13);
    doc.text("Publicação", 10, y);
    y += 8;

    doc.setFontSize(11);

    const textoPublicacao = doc.splitTextToSize(
      safeText(pub.pulicacao),
      180
    );

    doc.text(textoPublicacao, 10, y);
    y += textoPublicacao.length * 6 + 5;

    // ===== DESTINATÁRIOS =====
    doc.setFontSize(13);
    doc.text("Destinatários", 10, y);
    y += 8;

    doc.setFontSize(11);

    (pub.destinatarios || []).forEach(d => {
      doc.text(`• ${safeText(d.nome)} (${safeText(d.polo)})`, 10, y);
      y += 6;
    });

    y += 6;

    // ===== ADVOGADOS =====
    doc.setFontSize(13);
    doc.text("Advogados", 10, y);
    y += 8;

    doc.setFontSize(11);

    (pub.destinatariosAdvogados || []).forEach(a => {
      doc.text(`• ${safeText(a.nome)} - OAB ${safeText(a.oab)}`, 10, y);
      y += 6;
    });

    // ===== SALVAR =====
    doc.save(`publicacao_${pub.processo?.nrCnj || "arquivo"}.pdf`);
  };

	const statusTemplate = (data) => {
		return(
			<React.Fragment>
				<Tag className="p-mr-2" style={{backgroundColor: `${data.status?.cor}`}} value={data.status?.status}></Tag>
			</React.Fragment>
		)
	}

	const setModalAtividadeHide = (flag) => {
		setModalAtividadePublicacao(flag);
	}

	const setModalAtividadeInclusaoHide = (flag) => {
		setModalAtividadeInclusao(flag);
	}

	const linkAbrirAtividade = (rowData) => {
		return(
			<React.Fragment>
				<a onClick={() => consultarAtividade(rowData)} 
						style={{cursor: 'pointer', color: 'blue'}}>{rowData.titulo}</a>
			</React.Fragment>
		);
	}

	const consultarAtividade = async (atividade) => {
		const usuarioLogado = usuarioAutenticado;
		setOpenSpinner(true);
		await atividadeService.consultarAtividadeCustom(atividade.codigo,usuarioLogado.empresa.codigo,usuarioLogado.codigo)
			.then(response => {
				setAtividadeSelecionada(response.data);
				setOpenSpinner(false);
				setModalAtividadePublicacao(true);
			}).catch(error => {
				setOpenSpinner(false);
				this.toast.show({severity:'error', summary: 'Atividades', detail:`${error}`, life: 4000});
			})
	};

	const criarPrazo = async (pub) => {
		setPublicacaoSelecionada(pub);
		await consultarProcesso(pub?.processo);
	}

	const resumirEAbrirPublicacao = async (pub) => {
		setOpenSpinner(true);

		let resumoExistente = null;
		try {
			const historico = await resumoIntimacaoIaService.consultarHistorico(pub.codigo);
			resumoExistente = historico.data.find(item => item.status === 'CONCLUIDO');
		} catch (error) {
			console.log('Erro ao consultar histórico de Resumo de Intimação', error);
		}

		if (resumoExistente) {
			setOpenSpinner(false);
			window.open(`#/publicacao/${pub.codigo}`, '_blank');
			return;
		}

		await resumoIntimacaoIaService.gerarResumo(pub.codigo)
			.then(() => {
				setOpenSpinner(false);
				window.open(`#/publicacao/${pub.codigo}`, '_blank');
			}).catch(error => {
				console.log('Erro Resumo de Intimação', error);
				setOpenSpinner(false);
				toast.current.show({severity:'error', summary: 'Resumo de Intimação', detail:'Erro ao gerar o resumo da intimação', life: 4000});
			});
	}

	const atualizarPublicacoes = (atividadeAlterada) => {
		setPublicacoes(prevPublicacoes =>
			prevPublicacoes.map(pub => {

				const atividadeExiste = pub.atividades?.some(
					atv => atv.codigo === atividadeAlterada.codigo
				);

				if (!atividadeExiste) return pub;

				return {
					...pub,
					atividades: pub.atividades.map(atv =>
						atv.codigo === atividadeAlterada.codigo
							? atividadeAlterada
							: atv
					)
				};
			})
		);
	};

	const alterarProcesso = async (pub) => {
		if(pub?.processo?.statusProcessual == null) {
			toast.current.show({severity:'error', summary: 'Processo', detail:'Informe o Status Processual', life: 4000});
			return;
		}

		if(pub?.processo?.tipoDecisao == null) {
			toast.current.show({severity:'error', summary: 'Processo', detail:'Tipo de Decisão', life: 4000});
			return;
		}

		var dataUltimaDecisaoFormat = null;
		if (pub?.processo?.dataUltimaDecisao) {
			const date = new Date(pub.processo.dataUltimaDecisao);
			dataUltimaDecisaoFormat = date.toISOString().split('T')[0];
		}

		var dataDistribuicaoFormat = null;
		if (pub?.processo?.dataDistribuicao) {
			const date = new Date(pub.processo.dataDistribuicao);
			dataDistribuicaoFormat = date.toISOString().split('T')[0];
		}

		var dataSentencaFormat = null;
		if (pub?.processo?.dataSentenca) {
			const date = new Date(pub.processo.dataSentenca);
			dataSentencaFormat = date.toISOString().split('T')[0];
		}

		const processoAlterar = {
			codigoProcesso: pub?.processo?.codigo,
			statusProcessual: pub?.processo?.statusProcessual?.codigo,
			tipoDecisao: pub?.processo?.tipoDecisao?.codigo,
			dataUltimaDecisao: dataUltimaDecisaoFormat,
			dataDistribuicao: dataDistribuicaoFormat,
			dataSentenca: dataSentencaFormat
		}

		setOpenSpinner(true);
		await processoService.alterarProcessoPublicacao(processoAlterar)
			.then(response => {
				toast.current.show({severity:'success', summary: 'Processo', detail:'Processo Alterado com sucesso', life: 4000});
				setOpenSpinner(false);
			}).catch(error => {
				setOpenSpinner(false);
				toast.current.show({severity:'error', summary: 'Processo', detail:'Erro inesperado ao alterar processo', life: 4000});
			})
	}

	const consultarProcesso = async (processo) => {
		setOpenSpinner(true);
		await processoService.consultarProcessosPublicacao(processo.codigo)
			.then(response => {
				setOpenSpinner(false);
				console.log('Chegou processo ', response.data);
				setProcessoaSelecionado(response.data);
				setModalAtividadeInclusao(true);
			}).catch(error => {
				setOpenSpinner(false);
				toast.current.show({severity:'error', summary: 'Processos', detail:`${error}`, life: 4000});
			})
	}

	const pad2 = (n) => {
    return (n < 10 ? '0' : '') + n;
  }

  /* =========================
     RENDER
  ========================= */

  return (
    <div>

      <AtividadeComponent
					visible={modalAtividadePublicacao}
					atividade={atividadeSelecionada}
					historico={historicoAtividade}
					onHide={() => setModalAtividadeHide(false)}
					onAtividadeAlterada={atualizarPublicacoes}
			/>

			<Atividades
          visible={modalAtividades}
          atividades={atividades}
          onHide={() => setModalAtividades(false)}
      />

			<AtividadeComponentInclusao
					visible={modalAtividadeInclusao}
					processo={processoSelecionado}
					publicacao={publicacaoSelecionada}
					onHide={() => setModalAtividadeInclusaoHide(false)}
			/>

			<ConfirmDialog />

			 <Toast ref={toast} />

			<Backdrop
				sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
				open={openSpinner}>
				<CircularProgress color="primary" style={{width: '130px', height: '130px'}}/>
			</Backdrop>

      {/* DASHBOARD */}
      <DashboardPublicacoes filtro={filtro} />

			<br></br>
			<br></br>

      {publicacoes?.map((pub, index) => {

        const total = publicacoes?.length;
        const texto = pub.publicacao || pub.pulicacao; // aceita os dois nomes

        const textoFormatado = destacarTexto(texto, pub);

        return (
          <div key={index} style={{ marginBottom: "40px" }}>

            {/* TÍTULO */}
            <h5 style={{ marginBottom: "15px" }}>
              Publicação {index + 1} de {total}
            </h5>

            {/* STATUS */}
            <div style={{ marginBottom: "15px" }}>
              {lidas[pub.codigo]
								? <Tag severity="success" value="Lida" />
								: <Tag severity="warning" value="Pendente" />
							}
            </div>

            {/* BOTÕES */}
            <div
              style={{
                marginBottom: "20px",
                display: "flex",
                flexWrap: "nowrap",
                alignItems: "center",
                gap: "8px",
                overflowX: "auto",
                paddingBottom: "4px"
              }}
            >

              {pub.atividades.length > 0 && (
                <Button
                  label={`Prazo(s) criado(s) - ${pub.atividades.length}`}
                  icon="pi pi-check"
                  className="p-button-info p-button-sm"
                  style={{ whiteSpace: "nowrap" }}
                  onClick={() => consultaAtividades(pub.atividades)}
                />
              )}

              <Button
                label="Gerar prazo manual"
								onClick={() => criarPrazo(pub)}
                icon="pi pi-calendar-plus"
                className="p-button-success p-button-sm"
                style={{ whiteSpace: "nowrap" }}
              />

              <Button
                label="Resumir Publicação"
                icon="pi pi-align-justify"
                className="p-button-warning p-button-sm"
                style={{ whiteSpace: "nowrap" }}
                onClick={() => resumirEAbrirPublicacao(pub)}
              />

              <a
                href={gerarLinkProcesso(pub)}
                target="_blank"
                rel="noopener noreferrer"
                className="p-button p-component p-button-info p-button-sm"
                style={{ whiteSpace: "nowrap" }}
              >
                <span className="p-button-icon pi pi-external-link p-button-icon-left"></span>
                <span className="p-button-label">Ir para Processo</span>
              </a>

              <Button
                label="Exportar PDF"
                icon="pi pi-file-pdf"
                className="p-button-help p-button-sm"
                style={{ whiteSpace: "nowrap" }}
                onClick={() => gerarPDF(pub)}
              />

              <Button
                label="Exportar Word"
                icon="fas fa-file-word"
                className="p-button-primary p-button-sm"
                style={{ whiteSpace: "nowrap" }}
                onClick={() => gerarWord(pub)}
              />

              <Button
                label={lidas[pub.codigo] ? "Marcar como Pendente" : "Marcar como Lida"}
                icon="pi pi-check"
                className="p-button-secondary p-button-sm"
                style={{ whiteSpace: "nowrap" }}
                onClick={() => confirmarMarcarComoLida(pub, index)}
              />

            </div>

            {/* DADOS PRINCIPAIS */}
            <div style={{ fontFamily: "monospace", lineHeight: "1.8" }}>

              <Linha label="Data da Disponibilização" valor={pub.dataPublicacao} />
              <Linha label="Data da Publicação" valor={pub.dataDisponibilizacao} />

              <div style={{ display: "flex" }}>
                <div style={{ width: "260px", fontWeight: "bold" }}>
                  Tribunal :
                </div>
                <Tag
                  value={pub.tribunal}
                  severity={getTribunalColor(pub.tribunal)}
                />
              </div>
							<Linha 
									label="Link" 
									valor={
											<a href={pub.link} target="_blank" rel="noopener noreferrer">
													{pub.link}
											</a>
									} 
							/>
              <Linha label="Número do Processo" valor={pub.processo?.nrCnj} />
							<Linha label="Grupo de Trabalho" valor={pub.processo?.grupoTrabalho.nome} />
							<Linha label="Área de Atuação" valor={pub.processo?.areaAtuacao.nome} />
              <br></br>
							<Accordion multiple>
								<AccordionTab header="Dados do Processo">
									<div className="row">
										<div className="col-sm-12">
											<div className="form-group">
												<label>Partes</label>
												{pub.processo?.partes?.length > 0 ? (
													<table className="table table-sm table-bordered mt-2">
														<tbody>
															{pub.processo.partes.map((parte, index) => (
																<tr key={index}>
																	<td>{parte.pessoa.nome}&nbsp;&nbsp;-&nbsp;&nbsp;{parte.nomeTipo}</td>
																</tr>
															))}
														</tbody>
													</table>
												) : (
													<div className="text-muted mt-2">
														Nenhuma parte cadastrada
													</div>
												)}		
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-sm-6">
											<div className="form-group">
												<label>Status Processual</label>
												<Dropdown 
														value={pub.processo?.statusProcessual}
														options={statusProcessuais}
														style={{width: '100%', height: '32px'}}
														optionLabel="descricao"
														filter
														showClear
														filterBy="descricao"
														onChange={(e) => {
																const novasPublicacoes = publicacoes.map(p => {
																		if (p.codigo === pub.codigo) {
																				return {
																						...p,
																						processo: {
																								...p.processo,
																								statusProcessual: e.value
																						}
																				}
																		}
																		return p;
																});

																setPublicacoes(novasPublicacoes);
														}}
														className="p-inputtext-sm p-d-block p-mb-1"
												/>
											</div>
										</div>
										<div className="col-sm-6">
											<div className="form-group">
												<label>Tipo de Decisão</label>
												<Dropdown 
														value={pub.processo?.tipoDecisao}
														options={tiposDecisao}
														style={{width: '100%', height: '32px'}}
														optionLabel="nome"
														filter
														showClear
														filterBy="nome"
														onChange={(e) => {
																const novasPublicacoes = publicacoes.map(p => {
																		if (p.codigo === pub.codigo) {
																				return {
																						...p,
																						processo: {
																								...p.processo,
																								tipoDecisao: e.value
																						}
																				}
																		}
																		return p;
																});

																setPublicacoes(novasPublicacoes);
														}}
														className="p-inputtext-sm p-d-block p-mb-1"
												/>
											</div>
										</div>
									</div>
									<div className="row">
										<div className="col-sm-4">
											<div className="form-group">
												<label>Data Última Decisão</label>
												<Calendar
														value={converterData(pub.processo?.dataUltimaDecisao)}
														style={{width: '100%', height: '32px'}}
														onChange={(e) => {
																const novasPublicacoes = publicacoes.map(p => {
																		if (p.codigo === pub.codigo) {
																				return {
																						...p,
																						processo: {
																								...p.processo,
																								dataUltimaDecisao: e.value
																						}
																				}
																		}
																		return p;
																});

																setPublicacoes(novasPublicacoes);
														}}
														dateFormat="dd/mm/yy"
												/>
											</div>
										</div>
										<div className="col-sm-4">
											<div className="form-group">
												<label>Data de Distribuição</label>
												<Calendar
														value={converterData(pub.processo?.dataDistribuicao)}
														style={{width: '100%', height: '32px'}}
														onChange={(e) => {
																const novasPublicacoes = publicacoes.map(p => {
																		if (p.codigo === pub.codigo) {
																				return {
																						...p,
																						processo: {
																								...p.processo,
																								dataDistribuicao: e.value
																						}
																				}
																		}
																		return p;
																});

																setPublicacoes(novasPublicacoes);
														}}
														dateFormat="dd/mm/yy"
												/>
											</div>
										</div>
										<div className="col-sm-4">
											<div className="form-group">
												<label>Data da Sentença</label>
												<Calendar
														value={converterData(pub.processo?.dataSentenca)}
														style={{width: '100%', height: '32px'}}
														onChange={(e) => {
																const novasPublicacoes = publicacoes.map(p => {
																		if (p.codigo === pub.codigo) {
																				return {
																						...p,
																						processo: {
																								...p.processo,
																								dataSentenca: e.value
																						}
																				}
																		}
																		return p;
																});

																setPublicacoes(novasPublicacoes);
														}}
														dateFormat="dd/mm/yy"
												/>
											</div>
										</div>
									</div>
									<Button style={{height: '32px'}} 
									        type="button"
													onClick={() => alterarProcesso(pub)}
													className="p-button-success p-button-sm" >
										<i className="pi pi-save"></i>&nbsp;&nbsp;Salvar Processo
									</Button>
									
								</AccordionTab>
								<AccordionTab header="Atividades">
									<div className="row">
										<div className="col-sm-12">
											<div className="form-group">
											<DataTable value={pub.atividades}
															   responsiveLayout="scroll" size="small"
																 emptyMessage="Nenhuma Atividade">
															<Column body={statusTemplate} exportable={false} style={{ minWidth: '8rem' }} header="Status"/>
															<Column body={linkAbrirAtividade} exportable={false} style={{ minWidth: '8rem' }}header="Título"></Column>
															<Column field="responsaveis" header="Responsáveis"></Column>
															<Column field="dtLimite" header="Data Limite"></Column>
													</DataTable>
											</div>
										</div>
									</div>
								</AccordionTab>
							</Accordion>

            </div>

            {/* TEXTO */}
            <div style={{ marginTop: "20px" }}>
              <strong>Publicação:</strong>

              <div
                style={{
                  marginTop: "10px",
                  padding: "15px",
                  border: "1px solid #ccc",
                  borderRadius: "6px",
                  backgroundColor: "#f9f9f9",
                  whiteSpace: "pre-wrap",
                  fontFamily: "monospace",
                  lineHeight: "1.5"
                }}
                dangerouslySetInnerHTML={{ __html: textoFormatado }}
              />
            </div>

            {/* DESTINATÁRIOS */}
            <div style={{ marginTop: "25px" }}>
              <h6>Destinatários</h6>

              <DataTable
                value={Array.isArray(pub.destinatarios) ? pub.destinatarios : []}
                responsiveLayout="scroll"
                emptyMessage="Nenhum destinatário"
                className="p-datatable-sm"
              >
                <Column field="nome" header="Nome" />
                <Column field="polo" header="Polo" />
              </DataTable>
            </div>

            {/* ADVOGADOS */}
            <div style={{ marginTop: "25px" }}>
              <h6>Advogados</h6>

              <DataTable
                value={Array.isArray(pub.destinatariosAdvogados) ? pub.destinatariosAdvogados : []}
                responsiveLayout="scroll"
                emptyMessage="Nenhum advogado"
                className="p-datatable-sm"
              >
                <Column field="nome" header="Nome" />
                <Column field="oab" header="OAB" />
              </DataTable>
            </div>

						<hr style={{ marginTop: "30px" }} />

          </div>
        );
      })}
    </div>
  );
};


/* =========================
   COMPONENTE AUXILIAR
========================= */

const Linha = ({ label, valor }) => {

  return (
    <div style={{ display: "flex" }}>

      <div style={{ width: "260px", fontWeight: "bold" }}>
        {label} :
      </div>

      <div>
        {valor || "-"}
      </div>

    </div>
  );
};
export default PaginaPublicacaoDetalhada;